import RegisterAndProgress from './RegisterAndProgress';

export default RegisterAndProgress;
